import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const DocumentCsv = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "CSV document",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M14.7 2H6.5A1.5 1.5 0 0 0 5 3.5V16h1V3.5a.5.5 0 0 1 .5-.5H14v2.5A1.5 1.5 0 0 0 15.5 7H18v13.5a.5.5 0 0 1-.5.5H16v1h1.5a1.5 1.5 0 0 0 1.5-1.5V6.3zm.3 1.7L17.3 6h-1.8a.5.5 0 0 1-.5-.5zM5.002 17q.507 0 1.197.134l.24.048-.039.824a12 12 0 0 0-1.12-.077q-.729 0-.977.326-.25.326-.25 1.226t.24 1.245q.24.345.996.345l1.121-.077.029.834Q5.472 22 4.983 22q-1.092 0-1.542-.584Q3 20.822 3 19.48t.47-1.906Q3.937 17 5.001 17m5.77 1.092q-1.131-.153-1.638-.153-.508 0-.709.124-.191.115-.191.374 0 .258.21.364.22.105 1.016.249.804.135 1.14.43.335.298.335 1.055t-.489 1.11Q9.967 22 9.038 22q-.585 0-1.475-.163l-.297-.048.038-.871q1.15.153 1.658.153.507 0 .718-.125.22-.124.22-.412 0-.287-.21-.392-.202-.116-.987-.24-.776-.134-1.14-.412t-.364-1.015.498-1.101q.508-.364 1.293-.364.613 0 1.504.153l.297.057zm1.752-.987h-1.092l1.235 4.79h1.859l1.245-4.79h-1.063l-.958 3.899h-.307z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
